var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3001 6.2C22.6001 6 21.8001 6.5 21.7001 7.2L20.1 14L8.30005 13.9L5.5 2.5C5.4 2.1 5.20005 1.8 4.80005 1.6L2.20008 0.2C1.50008 -0.2 0.700028 0.1 0.400028 0.7C2.7597e-05 1.4 0.300028 2.2 0.900028 2.5L3 3.6L5.90003 15.2L4.30005 16.4C4.10005 16.5 4 16.8 4 17V18.9C4 19.3 4.30005 19.7 4.80005 19.7H7C6.7 20 6.5 20.4 6.5 20.8C6.5 21.7 7.2 22.3 8 22.3C8.9 22.3 9.5 21.6 9.5 20.8C9.5 20.4 9.3 20 9 19.7L19.2001 19.8C19.0001 20.1 18.9 20.4 18.9 20.8C18.9 21.7 19.6 22.3 20.4 22.3C21.2 22.3 21.9 21.6 21.9 20.8C21.9 20.5 21.8 20.1 21.6 19.9H22.9C23.3 19.9 23.7001 19.6 23.7001 19.1C23.7001 18.7 23.4 18.3 22.9 18.3L5.40003 18.1V17.3L6.70008 16.3C6.80008 16.3 6.89998 16.4 7.09998 16.4L21 16.5C21.6 16.5 22.2001 16.1 22.3001 15.4L24.1 7.5C24.5 7.1 24.1001 6.4 23.3001 6.2Z",
    fill: "#FAEDD9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 6.8H16.2001V3.2C16.2001 2.8 15.8 2.4 15.4 2.4H13C12.6 2.4 12.2001 2.8 12.2001 3.2V6.8H10.9C10.3 6.8 10.2 7.2 10.5 7.6L11.4 8.9L12.6 10.5L13.5 11.8C13.8 12.2 14.4001 12.2 14.7001 11.8L15.6 10.5L16.8 8.9L17.7001 7.6C18.2001 7.1 18 6.8 17.5 6.8Z",
    fill: "#FAEDD9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/Cart.ad0e3684fa370a34d3ea818da4966e83.svg";
export { ForwardRef as ReactComponent };